var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.setWindow),expression:"setWindow"}],staticStyle:{"background-color":"#f8f9fe"}},[_c('div',[_c('v-container',{staticClass:"d-flex align-center",staticStyle:{"height":"100vh"}},[_c('router-view')],1),_vm._v(" "),_c('alert')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }